// extracted by mini-css-extract-plugin
export default {"background":"DashboardFund_background__gClRh","font":"DashboardFund_font__VhQxN","title":"DashboardFund_title__yIaQa"};